// Совместимость: customerAuth — это просто проекция единого AuthContext.
// Провайдер делает passthrough, чтобы старые места с <CustomerAuthProvider> продолжали работать.
import React from 'react';
import { useAuth } from './AuthContext';

export function CustomerAuthProvider({ children }) {
  return <>{children}</>;
}

export function useCustomerAuth() {
  const { customer, loading, login, register, logout, getAuthHeader, updateCustomer } = useAuth();
  return { customer, loading, login, register, logout, getAuthHeader, updateCustomer };
}
